/**
 *
 * PluginIcon
 *
 */

import React from 'react'
import { ShoppingCart } from '@strapi/icons'

const PluginIcon: React.VoidFunctionComponent = () => <ShoppingCart />

export default PluginIcon
